export default {
  SET_ACTIVE_FEATURES: "feature/SET_ACTIVE_FEATURES",
  SET_ABTEST_ACTIVE_FEATURES: "feature/SET_ABTEST_ACTIVE_FEATURES",
  SET_ACTIVE_FEATURE_FLAGS: "feature/SET_ACTIVE_FEATURE_FLAGS"
};
